import { SettingsArray } from '@shared-types/util'

export function settingsListToMap<M>(settings: SettingsArray<M>): M {
  const result: Partial<M> = {}

  for (const { name, value } of settings) {
    result[name] = value
  }

  return result as M
}
